import React from 'react'
import './DeleteModal.css'

class DeleteModal extends React.Component {
  componentDidMount() {
    if (this.closeModal) {
      window.addEventListener('keydown', this.listenKeyboard.bind(this), true)
    }
  }
  componentWillUnmount() {
    if (this.closeModal) {
      window.removeEventListener('keydown', this.listenKeyboard.bind(this), true)
    }
  }
  listenKeyboard(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.closeModal()
    }
  }
  onOverlayClick() {
    this.props.closeDeleteModal()
  }
  onDialogClick(event) {
    event.stopPropagation()
  }
  render() {
    let display = 'block'
    if (this.props.hideDeleteModal) {
      display = 'none'
    }
    let toggleStyle = {display: display}
    return (
      <div style={toggleStyle}>
        <div className="modal-overlay" />
        <div className="modal-content" onClick={this.onOverlayClick.bind(this)}>
          <div className="modal-dialog" onClick={this.onDialogClick}>
            <div className="modal-header">
              <div className="modal-close" onClick={() => this.props.closeDeleteModal()}>x</div>
              <h2>Confirm deleting item</h2>
            </div>
            <div className="modal-body">
              You are about to delete this item. Are you sure you want to continue?
            </div>
            <div className="modal-footer">
              <button onClick={() => this.props.confirmDeleteSearchItem()}>OK</button>
              <button onClick={() => this.props.closeDeleteModal()}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DeleteModal


// WEBPACK FOOTER //
// ./src/components/DeleteModal.js